import { render, staticRenderFns } from "./images_modal.vue?vue&type=template&id=9d928b20&scoped=true"
import script from "./images_modal.vue?vue&type=script&lang=js"
export * from "./images_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d928b20",
  null
  
)

export default component.exports